// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "stop-3bmbm";
var _3 = "stop__label-4X3OV";
export { _1 as "__esModule", _2 as "stop", _3 as "stop__label" }
export default { "__esModule": _1, "stop": _2, "stop__label": _3 }
